import { render, staticRenderFns } from "./ModalMediaZoom.vue?vue&type=template&id=20f1b58e&scoped=true"
import script from "./ModalMediaZoom.vue?vue&type=script&lang=js"
export * from "./ModalMediaZoom.vue?vue&type=script&lang=js"
import style0 from "./ModalMediaZoom.vue?vue&type=style&index=0&id=20f1b58e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f1b58e",
  null
  
)

export default component.exports